import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=08d6f23d&"
import script from "./Contact.controller.js?vue&type=script&lang=js&"
export * from "./Contact.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Contact.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "7479006b"
  
)

export default component.exports